import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export class NoProductLinesAvailableEntity extends BaseEntityClass {
  constructor() {
    super();
    this.type = "no_product_lines_available";
    this.entity_version = 2;
  }
}
